import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="blocked-delete"
export default class extends Controller {
  static values = { message: String }

  alert(event) {
    event.preventDefault();
    window.alert(this.messageValue);
  }
}
